export default __webpack_public_path__ + "static/media/no-image.04612a62.svg";